import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.TypeAssetClassStrategyOptionsSortEnum>
) {
  const { sort, filter } = params;

  const {
    assetClassOptions: { items: data, total },
  } = await sdk.getListAssetClass2EnumOptions(
    filterSortPage({
      sort,
      filter,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { assetClass2Enum: data } = await sdk.getOneAssetClass2Enum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { assetClass2EnumMany: data } = await sdk.getManyAssetClass2Enum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const assetClassEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
